import script from "./TeacherRecordView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherRecordView.vue?vue&type=script&setup=true&lang=js"

import "./TeacherRecordView.vue?vue&type=style&index=0&id=2add5c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2add5c3c"]])

export default __exports__